export default __webpack_public_path__ + "static/media/delete.9611d90e.svg";